import type { ImageDimensions } from '@eliadmin/core/src/utils/image-dimensions';

// Original PNG dimensions verified against the published assets. API metadata wins.
export const BANNER_IMAGE_CONFIG: {
  dimensions: Readonly<Record<string, ImageDimensions>>;
} = {
  dimensions: {
    'https://api.najtonery.sk/files/g9MVIwGTtaJRIXsZmGwEKwKk77Zn5iB0dcKdxQmQ.png?ai=0': {
      width: 3360,
      height: 1120,
    },
    'https://api.najtonery.sk/files/rVXgYUxr8BHJVfRgRmucfNPlYHlpOfJriU06iZkb.png?ai=0': {
      width: 780,
      height: 1000,
    },
  },
};
